// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SJKN","image":"Header_image__1IHHi","name":"Header_name__3v4z2","info":"Header_info__2gI4f","infoRow":"Header_infoRow__1f7Xn"};